import { Observable } from 'rxjs';

// What the Manage-user dialog (roles + permissions per place) needs from a backend.
// Two screens use the same dialog with different APIs: the establishment
// "Manage Users" (branch staff, weight-bound) and the super admin "Users"
// (every user, every role, central or branch).
export interface UserAccessApi {
  canManage: boolean; // the signed-in user may change access (else read-only)
  allowCentralAssignment: boolean; // a role may be assigned centrally (no establishment)
  getAccess(sumId: number): Observable<any>;
  listAssignableRoles(): Observable<any[]>; // [{roleId, roleKey, roleName, applicableFor}]
  listEstablishments(): Observable<any[]>; // [{establishmentId, name}]
  assignRole(
    sumId: number,
    payload: { establishmentId: number | null; roleKey: string; validUntil?: string | null }
  ): Observable<any>;
  setRoleStatus(sumId: number, suremId: number, active: boolean): Observable<any>;
  listAssignablePermissions(): Observable<any[]>; // [{svpId, viewName, viewLabel, permission, permLabel, roles?}]
  grantPermission(sumId: number, suremId: number, svpId: number): Observable<any>;
  setPermissionStatus(sumId: number, supdId: number, active: boolean): Observable<any>;
  setPermissionsStatus(sumId: number, supdIds: number[], active: boolean): Observable<any>;
  // optional: drop every role of the user at one establishment
  removeFromEstablishment?(sumId: number, establishmentId: number): Observable<any>;
}

// establishments shown as select values: the central place has no id, so it is
// represented by 0 in the pickers (mat-select treats null as "no selection").
export const CENTRAL_PLACE_ID = 0;
